(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cr-aov-calculator"] && !Shopify.designMode) return;
  try {
    
    (function(){
        emailjs.init("2i48htRz-HRDWM8kH"); // Your Public Key
    })();
    document.addEventListener('DOMContentLoaded', function () {
        // Define question weights per type
        const questionWeights = {
            'q1': { 'CR': 1.0, 'AOV': 0.5 },
            'q2': { 'CR': 1.0, 'AOV': 0.5 },
            'q3': { 'CR': 1.0, 'AOV': 0.5 },
            'q4': { 'CR': 0.9, 'AOV': 0.4 },
            'q5': { 'CR': 0.9, 'AOV': 0.4 },
            'q6': { 'CR': 0.9, 'AOV': 0.4 },
            'q7': { 'CR': 0.5, 'AOV': 1.0 },
            'q8': { 'CR': 0.5, 'AOV': 1.0 },
            'q9': { 'CR': 0.5, 'AOV': 1.0 },
            'q10': { 'CR': 1.0, 'AOV': 0.5 },
            'q11': { 'CR': 1.0, 'AOV': 0.5 },
            'q12': { 'CR': 1.0, 'AOV': 0.5 },
            'q13': { 'CR': 1.0, 'AOV': 0.6 },
            'q14': { 'CR': 1.0, 'AOV': 0.6 },
            'q15': { 'CR': 1.0, 'AOV': 0.6 },
            'q16': { 'CR': 0.6, 'AOV': 1.0 },
            'q17': { 'CR': 0.6, 'AOV': 1.0 },
            'q18': { 'CR': 0.8, 'AOV': 0.4 },
            'q19': { 'CR': 0.8, 'AOV': 0.4 },
            'q20': { 'CR': 0.5, 'AOV': 1.0 }
        };

        // Define section weights per type
        const sectionWeights = {
            'Product Discovery and Navigation': { 'CR': 1.0, 'AOV': 0.5 },
            'Social Proof and UGC': { 'CR': 0.9, 'AOV': 0.4 },
            'User Experience and Site Performance': { 'CR': 1.0, 'AOV': 0.5 },
            'Checkout Experience': { 'CR': 1.0, 'AOV': 0.6 },
            'Trust and Credibility': { 'CR': 0.8, 'AOV': 0.4 },
            'Upselling and Cross-selling Strategies': { 'CR': 0.5, 'AOV': 1.0 },
            'Personalization and Engagement': { 'CR': 0.6, 'AOV': 1.0 },
            'Promotional Strategies': { 'CR': 0.5, 'AOV': 1.0 }
        };

        // Handle form submission
        document.getElementById('potentialForm').addEventListener('submit', function (e) {
            e.preventDefault();

            // Collect input values
            const clientName = document.getElementById('clientName').value;
            const clientBusiness = document.getElementById('clientBusiness').value;
            const email = document.getElementById('email').value;
            const consent = document.getElementById('consent').checked;

            if (!validateEmail(email) || !consent) {
                alert("Please provide valid inputs and agree to the consent.");
                return;
            }

            // Collect Likert scale responses
            const responses = {};
            for (let i = 1; i <= 20; i++) {
                const qValue = document.querySelector(`input[name="q${i}"]:checked`);
                if (qValue) {
                    responses[`q${i}`] = parseInt(qValue.value);
                } else {
                    alert(`Please answer question ${i}.`);
                    return;
                }
            }

            // Define question groups for scoring
            const sections = [
                { name: 'Product Discovery and Navigation', questions: ['q1', 'q2', 'q3'] },
                { name: 'Social Proof and UGC', questions: ['q4', 'q5', 'q6'] },
                { name: 'Upselling and Cross-selling Strategies', questions: ['q7', 'q8', 'q9'] },
                { name: 'User Experience and Site Performance', questions: ['q10', 'q11', 'q12'] },
                { name: 'Checkout Experience', questions: ['q13', 'q14', 'q15'] },
                { name: 'Personalization and Engagement', questions: ['q16', 'q17'] },
                { name: 'Trust and Credibility', questions: ['q18', 'q19'] },
                { name: 'Promotional Strategies', questions: ['q20'] }
            ];

            // Helper function to merge results
            function mergeResults(crResults, aovResults) {
                const resultMap = new Map();
            
                crResults.forEach(result => {
                    resultMap.set(result.sectionName, {
                        sectionName: result.sectionName,
                        totalScore: result.averageScore,
                        count: 1
                    });
                });
            
                aovResults.forEach(result => {
                    if (resultMap.has(result.sectionName)) {
                        const existing = resultMap.get(result.sectionName);
                        existing.totalScore += result.averageScore;
                        existing.count += 1;
                    } else {
                        resultMap.set(result.sectionName, {
                            sectionName: result.sectionName,
                            totalScore: result.averageScore,
                            count: 1
                        });
                    }
                });
            
                const mergedResults = [];
                resultMap.forEach(value => {
                    mergedResults.push({
                        sectionName: value.sectionName,
                        averageScore: value.totalScore / value.count
                    });
                });
            
                return mergedResults;
            }

            // Calculate average scores and potential improvements
            const crResults = calculateSectionScores(responses, sections, 'CR');
            const aovResults = calculateSectionScores(responses, sections, 'AOV');
        
            // Calculate overall potential improvements
            const crOverallImprovement = calculateOverallImprovement(crResults, 'CR');
            const aovOverallImprovement = calculateOverallImprovement(aovResults, 'AOV');
        
            // Merge results to avoid duplication
            const mergedResults = mergeResults(crResults, aovResults);
        
            // Generate the report
            const reportString = generateReport(clientName, clientBusiness, crOverallImprovement, aovOverallImprovement, crResults, aovResults, mergedResults);
        
            // Send report via EmailJS
            emailjs.send('service_f1yxxyh', 'template_beqzvab', {
                name: clientName,
                email: email,
                business: clientBusiness,
                date: new Date().toLocaleDateString(),
                cr_potential: crOverallImprovement.toFixed(1) + '%',
                aov_potential: aovOverallImprovement.toFixed(1) + '%',
                strengths_section: generateStrengths(mergedResults),
                weaknesses_section: generateWeaknesses(mergedResults),
                cr_recommendations: generateEmailRecommendations(crResults, 'CR'),
                aov_recommendations: generateEmailRecommendations(aovResults, 'AOV')
            })
            .then(function (response) {
                console.log('SUCCESS!', response.status, response.text);
            }, function (error) {
                console.log('FAILED...', error);
            });
        
            // Display the report
            document.getElementById('potentialReport').innerHTML = reportString;
            document.getElementById('result').style.display = 'block';
            document.getElementById('reportCover').style.display = 'none';
        });

        // Helper functions
        function validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(String(email).toLowerCase());
        }

        function calculateSectionScores(responses, sections, type) {
            const results = [];
            sections.forEach(section => {
                let total = 0;
                let weightSum = 0;
                section.questions.forEach(q => {
                    const weight = questionWeights[q][type];
                    total += responses[q] * weight;
                    weightSum += weight;
                });
                const averageScore = total / weightSum;
                const potentialImprovement = calculateImprovement(averageScore, type);
                const priorityScore = potentialImprovement * sectionWeights[section.name][type];
                results.push({
                    sectionName: section.name,
                    averageScore,
                    potentialImprovement,
                    priorityScore,
                    questions: section.questions
                });
            });
            return results;
        }

        function calculateImprovement(score, type) {
            let potentialImprovement = 0;
            if (type === 'CR') {
                if (score >= 1 && score <= 1.5) {
                    potentialImprovement = 37.5;
                } else if (score > 1.5 && score <= 2.5) {
                    potentialImprovement = 32.5;
                } else if (score > 2.5 && score <= 3.5) {
                    potentialImprovement = 22.5;
                } else if (score > 3.5 && score <= 4.5) {
                    potentialImprovement = 10;
                } else if (score > 4.5 && score <= 5) {
                    potentialImprovement = 0;
                }
            } else if (type === 'AOV') {
                if (score >= 1 && score <= 1.5) {
                    potentialImprovement = 23.75;
                } else if (score > 1.5 && score <= 2.5) {
                    potentialImprovement = 21.25;
                } else if (score > 2.5 && score <= 3.5) {
                    potentialImprovement = 15;
                } else if (score > 3.5 && score <= 4.5) {
                    potentialImprovement = 7.5;
                } else if (score > 4.5 && score <= 5) {
                    potentialImprovement = 0;
                }
            }
            return potentialImprovement;
        }

        function calculateOverallImprovement(results, type) {
            let totalPotential = 0;
            let totalWeight = 0;
            results.forEach(result => {
                if (result.potentialImprovement > 0) {
                    const weight = sectionWeights[result.sectionName][type];
                    totalPotential += result.potentialImprovement * weight;
                    totalWeight += weight;
                }
            });
            return totalWeight > 0 ? (totalPotential / totalWeight) : 0;
        }

        function generateReport(name, business, crOverallImprovement, aovOverallImprovement, crResults, aovResults, mergedResults) {
            return `
                <h2>CR & AOV Growth Potential Report</h2>
                <p><strong>Prepared for:</strong> ${name} from ${business}</p>
                <p><strong>Date:</strong> ${new Date().toLocaleDateString()}</p>
                <h3>Summary</h3>
                <p>Your eCommerce store has the potential to improve:</p>
                <ul>
                    <li><strong>Conversion Rate (CR)</strong> by up to <strong>${crOverallImprovement.toFixed(1)}%</strong>.</li>
                    <li><strong>Average Order Value (AOV)</strong> by up to <strong>${aovOverallImprovement.toFixed(1)}%</strong>.</li>
                </ul>
                ${generateInsights(crResults, aovResults, mergedResults)}
                <p>We recommend focusing on the areas with the highest potential improvements first to maximize your gains.</p>
            `;
        }

            function generateInsights(crResults, aovResults, mergedResults) {
                let insights = '';
        
                // Highlight Strengths
                const strengths = mergedResults.filter(result => result.averageScore >= 4.0);
                if (strengths.length > 0) {
                    insights += '<h3>Strengths</h3>';
                    insights += '<p>The following areas are performing well:</p>';
                    insights += '<ul>';
                    strengths.forEach(result => {
                        insights += `<li>${result.sectionName}</li>`;
                    });
                    insights += '</ul>';
                } else {
                    insights += '<h3>Strengths</h3>';
                    insights += '<p>Based on your completed form, there are currently no core strengths on your website.</p>';
                }
            
                // Highlight Weaknesses
                const weaknesses = mergedResults.filter(result => result.averageScore <= 3.0);
                if (weaknesses.length > 0) {
                    insights += '<h3>Weaknesses</h3>';
                    insights += '<p>The following areas need attention:</p>';
                    insights += '<ul>';
                    weaknesses.forEach(result => {
                        insights += `<li>${result.sectionName}</li>`;
                    });
                    insights += '</ul>';
                } else {
                    insights += '<h3>Weaknesses</h3>';
                    insights += '<p>Based on your completed form, there are currently no core weaknesses on your website.</p>';
                }
        
            // Process CR Results
            insights += '<h3>Conversion Rate (CR) Improvement Priorities</h3>';
            const crPriorities = crResults.filter(result => result.potentialImprovement > 0);
            if (crPriorities.length > 0) {
                crPriorities.sort((a, b) => b.priorityScore - a.priorityScore);
                insights += '<ol>';
                crPriorities.forEach(result => {
                    insights += `
                        <li>
                            <p><strong>${result.sectionName}:</strong></p>
                            <p>${getRecommendationText(result.sectionName, 'CR')}</p>
                        </li>
                    `;
                });
                insights += '</ol>';
            } else {
                insights += '<p>No significant areas for improvement in Conversion Rate were identified.</p>';
            }
        
            // Process AOV Results
            insights += '<h3>Average Order Value (AOV) Improvement Priorities</h3>';
            const aovPriorities = aovResults.filter(result => result.potentialImprovement > 0);
            if (aovPriorities.length > 0) {
                aovPriorities.sort((a, b) => b.priorityScore - a.priorityScore);
                insights += '<ol>';
                aovPriorities.forEach(result => {
                    insights += `
                        <li>
                            <p><strong>${result.sectionName}:</strong></p>
                            <p>${getRecommendationText(result.sectionName, 'AOV')}</p>
                        </li>
                    `;
                });
                insights += '</ol>';
            } else {
                insights += '<p>No significant areas for improvement in Average Order Value were identified.</p>';
            }
        
            return insights;
        }

        function generateEmailRecommendations(results, type) {
            let recommendations = '';
            const filteredResults = results
                .filter(result => result.potentialImprovement > 0)
                .sort((a, b) => b.priorityScore - a.priorityScore);
        
            if (filteredResults.length > 0) {
                filteredResults.forEach(result => {
                    recommendations += `
                        <li>
                            <p><strong>${result.sectionName}</strong></p>
                            <p>${getRecommendationText(result.sectionName, type)}</p>
                        </li>
                    `;
                });
            } else {
                recommendations = `<p>No significant areas for improvement in ${type === 'CR' ? 'Conversion Rate' : 'Average Order Value'} were identified.</p>`;
            }
            return recommendations;
        }

        function getRecommendationText(sectionName, type) {
            const recommendations = {
                'Product Discovery and Navigation': {
                    'CR': 'Enhance your site search with autocomplete and predictive suggestions, improve product categorization, and simplify navigation to help users find products quickly, thereby increasing conversion rates.',
                    'AOV': 'Introduce product bundling and recommend complementary products during navigation to encourage customers to add more items to their cart, thus increasing average order value.'
                },
                'Social Proof and UGC': {
                    'CR': 'Prominently display customer reviews and ratings across your site to build trust and reduce purchase hesitation, leading to higher conversion rates.',
                    'AOV': 'Showcase user-generated content featuring premium products or bundles to inspire customers to consider higher-value purchases.'
                },
                'User Experience and Site Performance': {
                    'CR': 'Optimize website load times and ensure mobile responsiveness to provide a seamless experience, reducing bounce rates and improving conversions.',
                    'AOV': 'Incorporate interactive elements and high-quality visuals that can encourage customers to spend more time on site and explore higher-priced items.'
                },
                'Checkout Experience': {
                    'CR': 'Streamline your checkout process by minimizing required fields, offering guest checkout, and displaying trust signals to reduce cart abandonment.',
                    'AOV': 'Provide options for customers to easily add related products or services at checkout, such as gift wrapping or extended warranties, to increase order value.'
                },
                'Trust and Credibility': {
                    'CR': 'Display trust badges, security certificates, and transparent return policies to alleviate customer concerns and boost conversions.',
                    'AOV': 'Offer assurances like satisfaction guarantees or customer support for higher-priced items to make customers comfortable with larger purchases.'
                },
                'Upselling and Cross-selling Strategies': {
                    'CR': 'Recommend popular or trending products to visitors to increase the likelihood of a purchase.',
                    'AOV': 'Implement upselling and cross-selling techniques by suggesting higher-priced alternatives or complementary products to boost the average order value.'
                },
                'Personalization and Engagement': {
                    'CR': 'Use personalized content and product recommendations based on browsing history to present relevant products, enhancing the chance of conversion.',
                    'AOV': 'Tailor product suggestions to include premium items or bundles that align with customer interests, encouraging them to spend more.'
                },
                'Promotional Strategies': {
                    'CR': 'Create urgency with time-limited offers and entry discounts to motivate immediate purchases and improve conversion rates.',
                    'AOV': 'Implement gamified promotions like free shipping thresholds, free gifts with purchase, buy-more-save-more deals, and subscription options to incentivize customers to increase their cart value.'
                }
            };
            return recommendations[sectionName][type] || '';
        }

        function generateStrengths(mergedResults) {
            let strengths = '';
            const strongAreas = mergedResults.filter(result => result.averageScore >= 4.0);
            if (strongAreas.length > 0) {
                strengths += '<h3>Strengths</h3>';
                strengths += '<p>The following areas are performing well:</p>';
                strengths += '<ul>';
                strongAreas.forEach(result => {
                    strengths += `<li>${result.sectionName}</li>`;
                });
                strengths += '</ul>';
            } else {
                strengths += '<h3>Strengths</h3>';
                strengths += '<p>Based on your completed form, there are currently no core strengths on your website.</p>';
            }
            return strengths;
        }

        function generateWeaknesses(mergedResults) {
            let weaknesses = '';
            const weakAreas = mergedResults.filter(result => result.averageScore <= 3.0);
            if (weakAreas.length > 0) {
                weaknesses += '<h3>Weaknesses</h3>';
                weaknesses += '<p>The following areas need attention:</p>';
                weaknesses += '<ul>';
                weakAreas.forEach(result => {
                    weaknesses += `<li>${result.sectionName}</li>`;
                });
                weaknesses += '</ul>';
            } else {
                weaknesses += '<h3>Weaknesses</h3>';
                weaknesses += '<p>Based on your completed form, there are currently no core weaknesses on your website.</p>';
            }
            return weaknesses;
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-region-switcher"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const preference = (() => {
      if (window.BlendRegionPreference) return window.BlendRegionPreference;
      const promptSuppressedUntilKey = 'blend_region_prompt_suppressed_until_v1';
      const selectedRegionKey = 'blend_region_selected_region_v1';
      const legacyDismissKey = 'blend_region_prompt_dismissed_session_v1';
      const legacySelectedRegionKey = 'blend_region_selected_region_session_v1';
      const channelName = 'blend_region_preference_v1';
      const suppressionDurationMs = 24 * 60 * 60 * 1000;
      const subscribers = new Set();
      let channel = null;

      function safeLocalGet(key) { try { return window.localStorage.getItem(key); } catch (error) { return null; } }
      function safeLocalSet(key, value) { try { window.localStorage.setItem(key, value); } catch (error) { return; } }
      function safeLocalRemove(key) { try { window.localStorage.removeItem(key); } catch (error) { return; } }
      function safeSessionGet(key) { try { return window.sessionStorage.getItem(key); } catch (error) { return null; } }
      function isRegionCode(region) { return region === 'US' || region === 'GB' || region === 'AU' || region === 'ROW'; }
      function getSuppressedUntil() { const value = Number.parseInt(safeLocalGet(promptSuppressedUntilKey), 10); return Number.isFinite(value) ? value : 0; }
      function clearExpiredSuppression() { const until = getSuppressedUntil(); if (until && Date.now() >= until) { safeLocalRemove(promptSuppressedUntilKey); safeLocalRemove(selectedRegionKey); } }
      function getSelectedRegion() { clearExpiredSuppression(); const region = safeLocalGet(selectedRegionKey) || safeSessionGet(legacySelectedRegionKey); return isRegionCode(region) ? region : null; }
      function isPromptSuppressed() { clearExpiredSuppression(); if (getSuppressedUntil() > Date.now()) return true; return safeSessionGet(legacyDismissKey) === 'true'; }
      function notify(message) { subscribers.forEach((callback) => { try { callback(message); } catch (error) { return; } }); }
      function emit(payload) { const message = Object.assign({ source: 'blend-region-preference', createdAt: Date.now() }, payload); notify(message); if (channel) { try { channel.postMessage(message); } catch (error) { return; } } }
      function suppressPrompt(options) {
        const settings = options || {};
        const suppressedUntil = Date.now() + suppressionDurationMs;
        const region = isRegionCode(settings.region) ? settings.region : null;
        safeLocalSet(promptSuppressedUntilKey, String(suppressedUntil));
        if (region) safeLocalSet(selectedRegionKey, region);
        emit({ type: 'regionPromptSuppressed', reason: settings.reason || 'manual', region: region, suppressedUntil: suppressedUntil });
      }
      function rememberRegionSelection(region, reason) { suppressPrompt({ region: region, reason: reason || 'region_selection' }); }
      function onChange(callback) { subscribers.add(callback); return () => subscribers.delete(callback); }

      try {
        channel = new BroadcastChannel(channelName);
        channel.addEventListener('message', (event) => {
          if (!event.data || event.data.source !== 'blend-region-preference') return;
          notify(event.data);
        });
      } catch (error) {
        channel = null;
      }

      window.addEventListener('storage', (event) => {
        if (event.key !== promptSuppressedUntilKey && event.key !== selectedRegionKey) return;
        notify({ source: 'blend-region-preference', type: 'regionPreferenceStorageChanged', region: getSelectedRegion(), suppressedUntil: getSuppressedUntil(), createdAt: Date.now() });
      });

      window.BlendRegionPreference = { getSelectedRegion: getSelectedRegion, isPromptSuppressed: isPromptSuppressed, isRegionCode: isRegionCode, onChange: onChange, rememberRegionSelection: rememberRegionSelection, suppressPrompt: suppressPrompt };
      return window.BlendRegionPreference;
    })();
    const regions = {
      US: { label: 'United States', flag: '🇺🇸', countries: ['US'] },
      GB: { label: 'United Kingdom', flag: '🇬🇧', countries: ['GB'] },
      AU: { label: 'Australia', flag: '🇦🇺', countries: ['AU'] },
      ROW: { label: 'Rest of the World', flag: '🌐', countries: [] }
    };

    function isRegionCode(region) { return preference.isRegionCode(region); }
    function getBasePath() {
      const path = window.location.pathname || '/';
      const lowerPath = path.toLowerCase();
      if (lowerPath === '/en-au' || lowerPath === '/en-gb') return '/';
      if (lowerPath.startsWith('/en-au/')) return path.slice(6) || '/';
      if (lowerPath.startsWith('/en-gb/')) return path.slice(6) || '/';
      return path;
    }
    function buildRegionUrl(region) {
      const basePath = getBasePath();
      const suffix = window.location.search + window.location.hash;
      let prefix = '';
      if (region === 'AU') prefix = '/en-au';
      if (region === 'GB') prefix = '/en-gb';
      if (!prefix) return basePath + suffix;
      return (basePath === '/' ? prefix : prefix + basePath) + suffix;
    }
    function updateRegionLinks(root) {
      root.querySelectorAll('[data-region-switcher-link][data-region-option]').forEach((link) => {
        link.setAttribute('href', buildRegionUrl(link.getAttribute('data-region-option')));
      });
    }
    function getCurrentRegion() {
      const path = window.location.pathname.toLowerCase();
      const selectedRegion = preference.getSelectedRegion();
      if (path === '/en-au' || path.startsWith('/en-au/')) return 'AU';
      if (path === '/en-gb' || path.startsWith('/en-gb/')) return 'GB';
      if (selectedRegion === 'US' || selectedRegion === 'ROW') return selectedRegion;
      if (window.Shopify && window.Shopify.country === 'US') return 'US';
      return 'ROW';
    }
    function getTargetRegion(countryCode) {
      const country = String(countryCode || '').toUpperCase();
      if (regions.AU.countries.includes(country)) return 'AU';
      if (regions.GB.countries.includes(country)) return 'GB';
      if (regions.US.countries.includes(country)) return 'US';
      return 'ROW';
    }
    function getSuggestionsUrl() {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      const prefix = root.endsWith('/') ? root : root + '/';
      const currentCountry = window.Shopify && window.Shopify.country ? window.Shopify.country : getCurrentRegion();
      return prefix + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(currentCountry);
    }
    async function getDetectedCountry() {
      const params = new URLSearchParams(window.location.search);
      const forcedRegion = params.get('region_prompt_debug');
      if (isRegionCode(forcedRegion)) return forcedRegion;
      if (!window.Shopify) return null;
      const response = await fetch(getSuggestionsUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return null;
      const data = await response.json();
      const detected = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      const suggested = data && data.suggestions && data.suggestions[0] && data.suggestions[0].parts && data.suggestions[0].parts.country && data.suggestions[0].parts.country.handle;
      return detected || suggested || null;
    }
    function applyRegionState(currentRegion, targetRegion) {
      const switcher = document.querySelector('[data-footer-region-switcher]');
      if (!switcher) return;
      updateRegionLinks(switcher);
      const current = regions[currentRegion] || regions.ROW;
      const summaryFlag = switcher.querySelector('[data-region-summary-flag]');
      const summaryLabel = switcher.querySelector('[data-region-summary-label]');
      if (summaryFlag) summaryFlag.textContent = current.flag;
      if (summaryLabel) summaryLabel.textContent = current.label;

      switcher.querySelectorAll('[data-region-option]').forEach((option) => {
        const optionRegion = option.getAttribute('data-region-option');
        const currentBadge = option.querySelector('[data-current-badge]');
        const recommendedBadge = option.querySelector('[data-recommended-badge]');
        const isCurrent = optionRegion === currentRegion;
        const isRecommended = optionRegion === targetRegion && optionRegion !== currentRegion;
        option.classList.toggle('is-active', isCurrent);
        option.classList.toggle('is-recommended', isRecommended);
        if (isCurrent) option.setAttribute('aria-current', 'true');
        else option.removeAttribute('aria-current');
        if (currentBadge) currentBadge.hidden = !isCurrent;
        if (recommendedBadge) recommendedBadge.hidden = !isRecommended;
      });
    }
    function moveFooterRegionSwitcher() {
      const switcher = document.querySelector('[data-footer-region-switcher]');
      const target = document.querySelector('.footer-block__brand-info');
      if (!switcher || !target || target.contains(switcher)) return;
      target.appendChild(switcher);
    }
    async function updateFooterRecommendation() {
      const currentRegion = getCurrentRegion();
      let targetRegion = currentRegion;
      try {
        targetRegion = getTargetRegion(await getDetectedCountry());
      } catch (error) {
        targetRegion = currentRegion;
      }
      applyRegionState(currentRegion, targetRegion);
    }
    function init() {
      moveFooterRegionSwitcher();
      updateFooterRecommendation();
    }

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-region-switcher-link]');
      if (!link) return;
      link.setAttribute('href', buildRegionUrl(link.getAttribute('data-region-option')));
      preference.rememberRegionSelection(link.getAttribute('data-region-option'), 'footer_region_switcher_click');
      const details = link.closest('details');
      if (details) details.open = false;
    }, true);

    preference.onChange(updateFooterRecommendation);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["region-recommendation-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const popup = document.querySelector('[data-region-recommendation-popup]');
    if (!popup || !window.Shopify) return;
    const modalLockKey = '__blendRegionPromptOpen';
    const promptDelayMs = Math.max(0, Number.parseInt(popup.getAttribute('data-region-popup-delay-ms'), 10) || 0);
    const competingSelectors = '[aria-modal="true"], [role="dialog"], .modal, .popup, .newsletter-popup, .exit-intent, iframe[src*="beehiiv"], iframe[src*="subscribe-forms"], [src*="beehiiv"], [src*="subscribe-forms"], [id*="beehiiv"], [class*="beehiiv"], [id*="bhv"], [class*="bhv"], [data-bhv], [class*="klaviyo"], [id*="klaviyo"], [class*="Klaviyo"], [id*="Klaviyo"], [class*="needsclick"], [class*="omnisend"], [id*="omnisend"]';
    const beehiivSelectors = 'iframe[src*="beehiiv"], iframe[src*="subscribe-forms"], [src*="beehiiv"], [src*="subscribe-forms"], [id*="beehiiv"], [class*="beehiiv"], [id*="bhv"], [class*="bhv"], [data-bhv]';
    const exitIntentEvents = ['mouseout', 'mouseleave', 'pointerout', 'pointerleave', 'mousemove', 'blur'];
    const regions = { US: { countries: ['US'] }, AU: { countries: ['AU'] }, GB: { countries: ['GB'] } };
    let pendingPrompt = false;
    let conflictObserver = null;
    let exitIntentBlockers = [];
    let promptDelayTimer = null;
    const preference = (() => {
      if (window.BlendRegionPreference) return window.BlendRegionPreference;
      const promptSuppressedUntilKey = 'blend_region_prompt_suppressed_until_v1';
      const selectedRegionKey = 'blend_region_selected_region_v1';
      const legacyDismissKey = 'blend_region_prompt_dismissed_session_v1';
      const legacySelectedRegionKey = 'blend_region_selected_region_session_v1';
      const channelName = 'blend_region_preference_v1';
      const suppressionDurationMs = 24 * 60 * 60 * 1000;
      const subscribers = new Set();
      let channel = null;

      function safeLocalGet(key) { try { return window.localStorage.getItem(key); } catch (error) { return null; } }
      function safeLocalSet(key, value) { try { window.localStorage.setItem(key, value); } catch (error) { return; } }
      function safeLocalRemove(key) { try { window.localStorage.removeItem(key); } catch (error) { return; } }
      function safeSessionGet(key) { try { return window.sessionStorage.getItem(key); } catch (error) { return null; } }
      function isRegionCode(region) { return region === 'US' || region === 'GB' || region === 'AU' || region === 'ROW'; }
      function getSuppressedUntil() { const value = Number.parseInt(safeLocalGet(promptSuppressedUntilKey), 10); return Number.isFinite(value) ? value : 0; }
      function clearExpiredSuppression() { const until = getSuppressedUntil(); if (until && Date.now() >= until) { safeLocalRemove(promptSuppressedUntilKey); safeLocalRemove(selectedRegionKey); } }
      function getSelectedRegion() { clearExpiredSuppression(); const region = safeLocalGet(selectedRegionKey) || safeSessionGet(legacySelectedRegionKey); return isRegionCode(region) ? region : null; }
      function isPromptSuppressed() { clearExpiredSuppression(); if (getSuppressedUntil() > Date.now()) return true; return safeSessionGet(legacyDismissKey) === 'true'; }
      function notify(message) { subscribers.forEach((callback) => { try { callback(message); } catch (error) { return; } }); }
      function emit(payload) { const message = Object.assign({ source: 'blend-region-preference', createdAt: Date.now() }, payload); notify(message); if (channel) { try { channel.postMessage(message); } catch (error) { return; } } }
      function suppressPrompt(options) {
        const settings = options || {};
        const suppressedUntil = Date.now() + suppressionDurationMs;
        const region = isRegionCode(settings.region) ? settings.region : null;
        safeLocalSet(promptSuppressedUntilKey, String(suppressedUntil));
        if (region) safeLocalSet(selectedRegionKey, region);
        emit({ type: 'regionPromptSuppressed', reason: settings.reason || 'manual', region: region, suppressedUntil: suppressedUntil });
      }
      function rememberRegionSelection(region, reason) { suppressPrompt({ region: region, reason: reason || 'region_selection' }); }
      function onChange(callback) { subscribers.add(callback); return () => subscribers.delete(callback); }

      try {
        channel = new BroadcastChannel(channelName);
        channel.addEventListener('message', (event) => {
          if (!event.data || event.data.source !== 'blend-region-preference') return;
          notify(event.data);
        });
      } catch (error) {
        channel = null;
      }

      window.addEventListener('storage', (event) => {
        if (event.key !== promptSuppressedUntilKey && event.key !== selectedRegionKey) return;
        notify({ source: 'blend-region-preference', type: 'regionPreferenceStorageChanged', region: getSelectedRegion(), suppressedUntil: getSuppressedUntil(), createdAt: Date.now() });
      });

      window.BlendRegionPreference = { getSelectedRegion: getSelectedRegion, isPromptSuppressed: isPromptSuppressed, isRegionCode: isRegionCode, onChange: onChange, rememberRegionSelection: rememberRegionSelection, suppressPrompt: suppressPrompt };
      return window.BlendRegionPreference;
    })();
    function isRegionCode(region) { return preference.isRegionCode(region); }
    function isDismissed() { return preference.isPromptSuppressed(); }
    function isPopupOpen() { return !popup.hidden; }
    function getBasePath() {
      const path = window.location.pathname || '/';
      const lowerPath = path.toLowerCase();
      if (lowerPath === '/en-au' || lowerPath === '/en-gb') return '/';
      if (lowerPath.startsWith('/en-au/')) return path.slice(6) || '/';
      if (lowerPath.startsWith('/en-gb/')) return path.slice(6) || '/';
      return path;
    }
    function buildRegionUrl(region) {
      const basePath = getBasePath();
      const suffix = window.location.search + window.location.hash;
      let prefix = '';
      if (region === 'AU') prefix = '/en-au';
      if (region === 'GB') prefix = '/en-gb';
      if (!prefix) return basePath + suffix;
      return (basePath === '/' ? prefix : prefix + basePath) + suffix;
    }
    function updateRegionLinks() {
      popup.querySelectorAll('[data-region-switcher-link][data-region-option]').forEach((link) => {
        link.setAttribute('href', buildRegionUrl(link.getAttribute('data-region-option')));
      });
    }
    function getCurrentRegion() {
      const path = window.location.pathname.toLowerCase();
      const selectedRegion = preference.getSelectedRegion();
      if (path === '/en-au' || path.startsWith('/en-au/')) return 'AU';
      if (path === '/en-gb' || path.startsWith('/en-gb/')) return 'GB';
      if (selectedRegion === 'US' || selectedRegion === 'ROW') return selectedRegion;
      if (window.Shopify.country === 'US') return 'US';
      return 'ROW';
    }
    function getTargetRegion(countryCode) {
      const country = String(countryCode || '').toUpperCase();
      if (regions.AU.countries.includes(country)) return 'AU';
      if (regions.GB.countries.includes(country)) return 'GB';
      if (regions.US.countries.includes(country)) return 'US';
      return 'ROW';
    }
    function getSuggestionsUrl() {
      const root = window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      const prefix = root.endsWith('/') ? root : root + '/';
      const currentCountry = window.Shopify.country || getCurrentRegion();
      return prefix + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(currentCountry);
    }
    async function getDetectedCountry() {
      const params = new URLSearchParams(window.location.search);
      const forcedRegion = params.get('region_prompt_debug');
      if (isRegionCode(forcedRegion)) return forcedRegion;
      const response = await fetch(getSuggestionsUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return null;
      const data = await response.json();
      const detected = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      const suggested = data && data.suggestions && data.suggestions[0] && data.suggestions[0].parts && data.suggestions[0].parts.country && data.suggestions[0].parts.country.handle;
      return detected || suggested || null;
    }
    function setBadges(currentRegion, targetRegion) {
      popup.querySelectorAll('[data-region-option]').forEach((option) => {
        const optionRegion = option.getAttribute('data-region-option');
        const currentBadge = option.querySelector('[data-current-badge]');
        const recommendedBadge = option.querySelector('[data-recommended-badge]');
        const isCurrent = optionRegion === currentRegion;
        const isRecommended = optionRegion === targetRegion && optionRegion !== currentRegion;
        option.classList.toggle('is-current', isCurrent);
        option.classList.toggle('is-recommended', isRecommended);
        if (currentBadge) currentBadge.hidden = !isCurrent;
        if (recommendedBadge) recommendedBadge.hidden = !isRecommended;
      });
    }
    function isVisibleElement(element) { if (!element || element === popup || popup.contains(element)) return false; const style = window.getComputedStyle(element); if (style.display === 'none' || style.visibility === 'hidden' || style.pointerEvents === 'none' || Number(style.opacity) === 0) return false; const rect = element.getBoundingClientRect(); if (rect.width < 1 || rect.height < 1) return false; if (rect.bottom <= 0 || rect.right <= 0 || rect.top >= window.innerHeight || rect.left >= window.innerWidth) return false; return true; }
    function getElementIdentity(element) { return `${element.id || ''} ${element.className || ''} ${element.getAttribute('src') || ''}`; }
    function getNumericZIndex(element) { const value = window.getComputedStyle(element).zIndex; const zIndex = Number.parseInt(value, 10); return Number.isFinite(zIndex) ? zIndex : 0; }
    function isFullscreenOverlay(element) { if (!isVisibleElement(element)) return false; const style = window.getComputedStyle(element); if (style.position !== 'fixed') return false; if (getNumericZIndex(element) < 100000) return false; const rect = element.getBoundingClientRect(); const coversViewport = rect.width >= window.innerWidth * 0.75 && rect.height >= window.innerHeight * 0.75 && rect.left <= 40 && rect.top <= 40; const background = style.backgroundColor || ''; const hasBackdrop = background !== '' && background !== 'transparent' && background !== 'rgba(0, 0, 0, 0)'; return coversViewport && hasBackdrop; }
    function isVisibleCompetingPopup(element) { if (!isVisibleElement(element)) return false; const style = window.getComputedStyle(element); const rect = element.getBoundingClientRect(); if (rect.width < 120 || rect.height < 80) return false; const identity = getElementIdentity(element); const modalLike = element.getAttribute('role') === 'dialog' || element.getAttribute('aria-modal') === 'true' || /modal|popup|beehiiv|bhv|subscribe-forms|exit|newsletter|klaviyo|needsclick|omnisend/i.test(identity); const overlayLike = style.position === 'fixed' || style.position === 'sticky' || style.position === 'absolute' || getNumericZIndex(element) >= 1000; return modalLike && overlayLike; }
    function getVisibleBeehiivOverlays() { const overlays = []; const markers = Array.from(document.querySelectorAll(beehiivSelectors)); markers.forEach((marker) => { let element = marker; for (let depth = 0; element && depth < 8; depth += 1) { if (isVisibleCompetingPopup(element) || isFullscreenOverlay(element)) { overlays.push(element); break; } element = element.parentElement; } }); return Array.from(new Set(overlays)); }
    function hasVisibleBeehiivPopup() { return getVisibleBeehiivOverlays().length > 0; }
    function suppressVisibleBeehiivPopups() { const overlays = getVisibleBeehiivOverlays(); overlays.forEach((element) => { element.setAttribute('aria-hidden', 'true'); element.style.setProperty('display', 'none', 'important'); element.style.setProperty('visibility', 'hidden', 'important'); }); return overlays.length > 0; }
    function hasVisibleCompetingPopup() { const targeted = Array.from(document.querySelectorAll(competingSelectors)).some((element) => isVisibleCompetingPopup(element) || isFullscreenOverlay(element)); const fullscreen = Array.from(document.body.children).some(isFullscreenOverlay); return targeted || fullscreen || hasVisibleBeehiivPopup(); }
    function shouldBlockExitIntentEvent(event) { if (!isPopupOpen()) return false; if (event.type === 'mousemove') return typeof event.clientY === 'number' && event.clientY <= 8; if (event.type === 'mouseout' || event.type === 'pointerout') return event.relatedTarget === null; return true; }
    function blockExitIntentEvent(event) { if (!shouldBlockExitIntentEvent(event)) return; event.stopImmediatePropagation(); }
    function addExitIntentBlocker(target, type) { target.addEventListener(type, blockExitIntentEvent, true); exitIntentBlockers.push({ target: target, type: type, handler: blockExitIntentEvent }); }
    function enableModalLock() { window[modalLockKey] = true; if (exitIntentBlockers.length) return; exitIntentEvents.forEach((type) => addExitIntentBlocker(window, type)); exitIntentEvents.forEach((type) => addExitIntentBlocker(document, type)); addExitIntentBlocker(document, 'visibilitychange'); }
    function disableModalLock() { window[modalLockKey] = false; exitIntentBlockers.forEach((entry) => entry.target.removeEventListener(entry.type, entry.handler, true)); exitIntentBlockers = []; }
    function clearPromptDelay() { if (!promptDelayTimer) return; window.clearTimeout(promptDelayTimer); promptDelayTimer = null; }
    function hidePrompt() { pendingPrompt = false; clearPromptDelay(); disableModalLock(); popup.hidden = true; document.documentElement.classList.remove('region-recommendation-popup-open'); }
    function suppressForDay(reason) { preference.suppressPrompt({ reason: reason || 'popup_dismissed' }); hidePrompt(); }
    function openPopup() { popup.hidden = false; document.documentElement.classList.add('region-recommendation-popup-open'); enableModalLock(); suppressVisibleBeehiivPopups(); const closeButton = popup.querySelector('[data-region-popup-close]'); if (closeButton) closeButton.focus({ preventScroll: true }); }
    function closePopup() { suppressForDay('popup_dismissed'); }
    function attemptOpen() { promptDelayTimer = null; if (!pendingPrompt || isDismissed()) return; if (hasVisibleCompetingPopup()) { suppressForDay('competing_popup_visible'); return; } openPopup(); }
    function scheduleOpen() { clearPromptDelay(); if (promptDelayMs > 0) { promptDelayTimer = window.setTimeout(attemptOpen, promptDelayMs); return; } attemptOpen(); }
    function handlePopupConflicts() { if (!pendingPrompt || isDismissed()) return; if (isPopupOpen()) { if (suppressVisibleBeehiivPopups()) return; if (hasVisibleCompetingPopup()) suppressForDay('competing_popup_visible'); return; } if (hasVisibleCompetingPopup()) suppressForDay('competing_popup_visible'); }
    function watchForPopupConflicts() { if (conflictObserver) return; conflictObserver = new MutationObserver(handlePopupConflicts); conflictObserver.observe(document.body, { attributes: true, childList: true, subtree: true, attributeFilter: ['aria-hidden', 'aria-modal', 'class', 'hidden', 'role', 'src', 'style'] }); }
    preference.onChange(hidePrompt);
    popup.addEventListener('click', (event) => { if (event.target === popup || event.target.closest('[data-region-popup-close]')) closePopup(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !popup.hidden) closePopup(); });
    document.addEventListener('click', (event) => { const link = event.target.closest('[data-region-switcher-link]'); if (!link) return; link.setAttribute('href', buildRegionUrl(link.getAttribute('data-region-option'))); preference.rememberRegionSelection(link.getAttribute('data-region-option'), 'region_switcher_click'); }, true);
    async function init() { updateRegionLinks(); if (isDismissed()) return; try { const currentRegion = getCurrentRegion(); const detectedCountry = await getDetectedCountry(); if (isDismissed()) return; const targetRegion = getTargetRegion(detectedCountry); if (targetRegion === currentRegion) return; setBadges(currentRegion, targetRegion); pendingPrompt = true; watchForPopupConflicts(); scheduleOpen(); } catch (error) { return; } }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roi-calculator"] && !Shopify.designMode) return;
  try {
    
    (function(){
        emailjs.init("2i48htRz-HRDWM8kH"); // Your Public Key
    })();
    document.addEventListener('DOMContentLoaded', function () {
        // Initialize variables for toggles
        let increaseCR = 22.5; // Initial Conversion Rate Increase (%)
        let increaseAOV = 15.0; // Initial AOV Increase (%)

        // Update the display values for toggles
        document.getElementById('increaseCRValue').value = increaseCR;
        document.getElementById('increaseAOVValue').value = increaseAOV;

        // Conversion Rate Increase Toggle Buttons
        document.getElementById('crPlus').addEventListener('click', function () {
            if (increaseCR < 100) {
                increaseCR += 2.5;
                document.getElementById('increaseCRValue').value = increaseCR;
            }
        });

        document.getElementById('crMinus').addEventListener('click', function () {
            if (increaseCR > 0) {
                increaseCR -= 2.5;
                document.getElementById('increaseCRValue').value = increaseCR;
            }
        });

        // AOV Increase Toggle Buttons
        document.getElementById('aovPlus').addEventListener('click', function () {
            if (increaseAOV < 100) {
                increaseAOV += 2.5;
                document.getElementById('increaseAOVValue').value = increaseAOV;
            }
        });

        document.getElementById('aovMinus').addEventListener('click', function () {
            if (increaseAOV > 0) {
                increaseAOV -= 2.5;
                document.getElementById('increaseAOVValue').value = increaseAOV;
            }
        });

        // Define conversion rates for different currencies
        const exchangeRates = {
            'USD': 1,     // Base currency
            'EUR': 0.937,
            'GBP': 0.7499,
            'AUD': 1.5
        };

        // Handle form submission
        document.getElementById('roiForm').addEventListener('submit', function (e) {
            e.preventDefault();

            // Collect input values
            const totalRevenue = parseFloat(document.getElementById('totalRevenue').value);
            const currentCR = parseFloat(document.getElementById('currentCR').value);
            const averageOrderValue = parseFloat(document.getElementById('averageOrderValue').value);
            const profitRatio = parseFloat(document.getElementById('profitRatio').value);
            const email = document.getElementById('email').value;
            const consent = document.getElementById('consent').checked;
            const clientName = document.getElementById('clientName').value;
            const clientBusiness = document.getElementById('clientBusiness').value;
            const selectedCurrency = document.getElementById('Select-currency').value;

            if (!validateEmail(email) || !consent) {
                alert("Please provide valid inputs and agree to the consent.");
                return;
            }

            // User-defined target metrics from toggles
            const targetCRIncrease = increaseCR / 100;
            const targetAOVIncrease = increaseAOV / 100;

            // Calculate traffic
            const traffic = totalRevenue / (currentCR / 100 * averageOrderValue);

            // Initial monthly growth rates to reach target increases in 12 months
            const monthlyCRGrowth = Math.pow(1 + targetCRIncrease, 1 / 12) - 1;
            const monthlyAOVGrowth = Math.pow(1 + targetAOVIncrease, 1 / 12) - 1;

            let currentCRValue = currentCR;
            let currentAOVValue = averageOrderValue;

            // Convert CRO program cost to the selected currency
            const selectedCurrencyRate = exchangeRates[selectedCurrency] || 1;
            const minMonthCost = 3999 * selectedCurrencyRate;
            const maxMonthCost = 11999 * selectedCurrencyRate;
            const perMonthCost = totalRevenue / 100 * 1.5 * selectedCurrencyRate;
            
            let monthlyCROCost = 0;
            
            if (perMonthCost >= maxMonthCost) {
            monthlyCROCost = maxMonthCost;
            } else if (perMonthCost <= minMonthCost) {
            monthlyCROCost = minMonthCost;
            } else {
            monthlyCROCost = perMonthCost;
            }
            const auditCost = 3999 * selectedCurrencyRate;
            const programCost12 = monthlyCROCost * 12 + auditCost;
            const programCost36 = monthlyCROCost * 36 + auditCost;
            const programCost60 = monthlyCROCost * 60 + auditCost;

            let cumulativeRevenue = 0;
            let cumulativeProfit = 0;

            const monthlyData = [];
            let cumulativeProfit12 = 0;
            let cumulativeProfit36 = 0;
            let cumulativeProfit60 = 0;

            for (let month = 1; month <= 60; month++) {
                let currentMonthlyCRGrowth, currentMonthlyAOVGrowth;

                if (month <= 12) {
                    // Months 1-12: Use initial monthly growth rates
                    currentMonthlyCRGrowth = monthlyCRGrowth;
                    currentMonthlyAOVGrowth = monthlyAOVGrowth;
                } else {
                    // Months 13-60: Decrease growth rates linearly to zero
                    const monthsSince12 = month - 12;
                    const totalMonthsAfter12 = 48; // Months 13 to 60
                    const decreasingFactor = 1 - (monthsSince12 / totalMonthsAfter12);

                    currentMonthlyCRGrowth = monthlyCRGrowth * decreasingFactor;
                    currentMonthlyAOVGrowth = monthlyAOVGrowth * decreasingFactor;
                }

                // Update current CR and AOV values
                currentCRValue *= (1 + currentMonthlyCRGrowth);
                currentAOVValue *= (1 + currentMonthlyAOVGrowth);

                // Calculate new revenue and profits
                const newRevenue = traffic * (currentCRValue / 100) * currentAOVValue;
                const extraRevenue = newRevenue - totalRevenue;
                const monthlyProfit = extraRevenue * (profitRatio / 100);

                cumulativeRevenue += extraRevenue;
                cumulativeProfit += monthlyProfit;

                // Store cumulative profits at specific milestones
                if (month === 12) cumulativeProfit12 = cumulativeProfit;
                if (month === 36) cumulativeProfit36 = cumulativeProfit;
                if (month === 60) cumulativeProfit60 = cumulativeProfit;

                const cumulativeCost = monthlyCROCost * month;
                const monthlyROI = ((cumulativeProfit - cumulativeCost) / cumulativeCost) * 100;

                monthlyData.push({
                    month,
                    cr: currentCRValue.toFixed(2),
                    aov: formatCurrency(currentAOVValue, selectedCurrency),
                    revenue: formatCurrency(newRevenue, selectedCurrency),
                    cumulativeRevenue: formatCurrency(cumulativeRevenue, selectedCurrency),
                    cumulativeProfit: formatCurrency(cumulativeProfit, selectedCurrency),
                    roi: monthlyROI.toFixed(2)
                });
            }

            // Find breakeven month
            let breakevenMonth = monthlyData.findIndex((data, index) => {
                if (index > 0) {
                    const cumulativeCostAtMonth = monthlyCROCost * index;
                    return parseFloat(data.cumulativeProfit.replace(/[^0-9.-]+/g, "")) >= cumulativeCostAtMonth;
                }
                return false;
            });

            breakevenMonth = breakevenMonth >= 0 ? breakevenMonth + 1 : "No breakeven point within 60 months";

            const roi12 = ((cumulativeProfit12 - programCost12) / programCost12) * 100;
            const roi36 = ((cumulativeProfit36 - programCost36) / programCost36) * 100;
            const roi60 = ((cumulativeProfit60 - programCost60) / programCost60) * 100;

            const breakevenMessage = breakevenMonth !== "No breakeven point within 60 months"
                ? `Based on the indicated target Conversion Rate and the Target Average Order Value, we calculate that you would break even on this program in Month ${breakevenMonth}.`
                : `Based on the indicated target Conversion Rate and the Target Average Order Value, it appears you would not break even within the next 5 years due to diminishing returns.`;

            // Generate the report
            const reportString = `
            <h2>CRO Program ROI Report</h2>
            <p><strong>Prepared for:</strong> ${clientName} from ${clientBusiness}</p>
            <p><strong>Prepared by:</strong> Blend Commerce</p>
            <p><strong>Date:</strong> ${new Date().toLocaleDateString()}</p>
            <p>This report provides a detailed projection of the expected impact of an investment in a CRO program. It highlights key performance metrics such as the breakeven point, monthly revenue projections, cumulative additional revenue, and ROI over 1, 3, and 5 years.</p>
            <p><strong>Note:</strong> This report takes into account the natural slowing of growth over time as the website becomes more Optimised. As a site reaches a higher level of optimization, further improvements become more challenging to achieve significant gains. Additionally, this report does not consider the potential impact of improving other core growth metrics, such as Purchase Frequency, Customer Retention Rate, and Customer Acquisition Costs, which can also play a significant role in overall business growth.</p>
            
            <h3>Current Situation</h3>
            <ul>
                <li><strong>Current Monthly Revenue:</strong> ${formatCurrency(totalRevenue, selectedCurrency)}</li>
                <li><strong>Current Conversion Rate (CR):</strong> ${currentCR}%</li>
                <li><strong>Current Average Order Value (AOV):</strong> ${formatCurrency(averageOrderValue, selectedCurrency)}</li>
                <li><strong>Net Profit Margin:</strong> ${profitRatio}%</li>
            </ul>
            
            <h3>Targeted Metrics after 1 Year of a CRO program:</h3>
            <ul>
                <li><strong>Target Monthly Revenue:</strong> ${monthlyData[11].revenue}</li>
                <li><strong>Target Conversion Rate:</strong> ${(monthlyData[11].cr)}%</li>
                <li><strong>Target AOV:</strong> ${monthlyData[11].aov}</li>
            </ul>
            
            <h3>Revenue & ROI Projections</h3>
            <p><strong>Breakeven:</strong> ${breakevenMessage}</p>
            
            <p><strong>Year 1 Projections:</strong></p>
            <ul>
                <li><strong>Projected Revenue in Month 12:</strong> ${monthlyData[11].revenue}</li>
                <li><strong>Cumulative Additional Revenue after 1 year:</strong> ${monthlyData[11].cumulativeRevenue}</li>
                <li><strong>Cumulative Additional Profit after 1 year:</strong> ${monthlyData[11].cumulativeProfit}</li>
                <li><strong>ROI after 1 Year:</strong> ${roi12.toFixed(2)}%</li>
            </ul>
            
            <p><strong>Year 3 Projections:</strong></p>
            <ul>
                <li><strong>Projected Revenue in Month 36:</strong> ${monthlyData[35].revenue}</li>
                <li><strong>Cumulative Additional Revenue after 3 Years:</strong> ${monthlyData[35].cumulativeRevenue}</li>
                <li><strong>Cumulative Additional Profit after 3 Years:</strong> ${monthlyData[35].cumulativeProfit}</li>
                <li><strong>ROI after 3 Years:</strong> ${roi36.toFixed(2)}%</li>
            </ul>
            
            <p><strong>Year 5 Projection:</strong></p>
            <ul>
                <li><strong>Projected Revenue in Month 60:</strong> ${monthlyData[59].revenue}</li>
                <li><strong>Cumulative Additional Revenue after 5 Years:</strong> ${monthlyData[59].cumulativeRevenue}</li>
                <li><strong>Cumulative Additional Profit after 5 Years:</strong> ${monthlyData[59].cumulativeProfit}</li>
                <li><strong>ROI after 5 Years:</strong> ${roi60.toFixed(2)}%</li>
            </ul>
            `;

            // Send report via EmailJS
            emailjs.send('service_f1yxxyh', 'template_tnye1b8', {
                name: clientName,
                email: email,
                business: clientBusiness,
                currency: selectedCurrency,
                revenue: formatCurrency(totalRevenue, selectedCurrency),
                conversion_rate: currentCR + '%',
                average_order_value: formatCurrency(averageOrderValue, selectedCurrency),
                profit_margin: profitRatio + '%',
                breakeven_message: breakevenMessage, // Use calculated breakeven message
                target_monthly_revenue: monthlyData[11].revenue,
                target_conversion_rate: monthlyData[11].cr + '%',
                target_aov: monthlyData[11].aov,
                projected_revenue_12: monthlyData[11].revenue,
                cumulative_additional_revenue_12: monthlyData[11].cumulativeRevenue,
                cumulative_additional_profit_12: monthlyData[11].cumulativeProfit,
                roi12: roi12.toFixed(2) + '%',
                projected_revenue_36: monthlyData[35].revenue,
                cumulative_additional_revenue_36: monthlyData[35].cumulativeRevenue,
                cumulative_additional_profit_36: monthlyData[35].cumulativeProfit,
                roi36: roi36.toFixed(2) + '%',
                projected_revenue_60: monthlyData[59].revenue,
                cumulative_additional_revenue_60: monthlyData[59].cumulativeRevenue,
                cumulative_additional_profit_60: monthlyData[59].cumulativeProfit,
                roi60: roi60.toFixed(2) + '%',
                total_cost_12: formatCurrency(programCost12, selectedCurrency),
                total_cost_36: formatCurrency(programCost36, selectedCurrency),
                total_cost_60: formatCurrency(programCost60, selectedCurrency),
                date: new Date().toLocaleDateString() // Send the current date
            })
            .then(function (response) {
                console.log('SUCCESS!', response.status, response.text);
            }, function (error) {
                console.log('FAILED...', error);
            });

            // Display the report
            document.getElementById('roiReport').innerHTML = reportString;
            document.getElementById('result').style.display = 'block';
            document.getElementById('disclaimer').style.display = 'block';
            document.getElementById('reportCover').style.display = 'none';
        });

        // Helper functions
        function formatCurrency(num, currency) {
            let symbol = '';
            switch (currency) {
                case 'USD':
                    symbol = '$';
                    break;
                case 'EUR':
                    symbol = '€';
                    break;
                case 'GBP':
                    symbol = '£';
                    break;
                case 'AUD':
                    symbol = 'A$';
                    break;
                default:
                    symbol = '';
            }
            return symbol + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }

        function validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(String(email).toLowerCase());
        }
    });

  } catch(e) { console.error(e); }
})();
})();
